var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87734 17.7481C6.87773 17.9938 6.95039 18.2344 7.08672 18.4391L7.7543 19.4426C7.86834 19.6142 8.02302 19.7549 8.20457 19.8522C8.38613 19.9495 8.58893 20.0004 8.79492 20.0004H11.2055C11.4115 20.0004 11.6143 19.9495 11.7958 19.8522C11.9774 19.7549 12.1321 19.6142 12.2461 19.4426L12.9137 18.4391C13.0499 18.2344 13.1228 17.994 13.123 17.7481L13.1246 16.25H6.87539L6.87734 17.7481ZM3.125 6.87503C3.125 8.60824 3.76758 10.1895 4.82656 11.3977C5.47188 12.134 6.48125 13.6723 6.86602 14.97C6.86758 14.9801 6.86875 14.9903 6.87031 15.0004H13.1297C13.1312 14.9903 13.1324 14.9805 13.134 14.97C13.5188 13.6723 14.5281 12.134 15.1734 11.3977C16.2324 10.1895 16.875 8.60824 16.875 6.87503C16.875 3.07074 13.7855 -0.0116854 9.97852 3.33038e-05C5.99375 0.0121427 3.125 3.24105 3.125 6.87503ZM10 3.75003C8.27695 3.75003 6.875 5.15199 6.875 6.87503C6.875 7.22035 6.59531 7.50003 6.25 7.50003C5.90469 7.50003 5.625 7.22035 5.625 6.87503C5.625 4.46253 7.5875 2.50003 10 2.50003C10.3453 2.50003 10.625 2.77972 10.625 3.12503C10.625 3.47035 10.3453 3.75003 10 3.75003Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS6);
export default __webpack_public_path__ + "static/media/s6.25c193e3527065476a9a6e796427f9ed.svg";
export { ForwardRef as ReactComponent };